import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import updateLocale from 'dayjs/plugin/updateLocale';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import toObject from 'dayjs/plugin/toObject';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import dayjsBusinessDays from 'dayjs-business-days2';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/es';
import 'dayjs/locale/de';

dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(toObject);
dayjs.extend(customParseFormat);
dayjs.extend(quarterOfYear);
dayjs.extend(dayjsBusinessDays);
dayjs.extend(updateLocale);

dayjs.updateLocale('en', {
  formats: {
    L: 'DD/MM/YYYY'
  }
});

export const toISOLocal = (d: Date) => {
  const z = (n: number) => ('0' + n).slice(-2);
  const zz = (n: number) => ('00' + n).slice(-3);
  let off = d.getTimezoneOffset();
  const sign = off > 0 ? '-' : '+';
  off = Math.abs(off);

  return (
    d.getFullYear() +
    '-' +
    z(d.getMonth() + 1) +
    '-' +
    z(d.getDate()) +
    'T' +
    z(d.getHours()) +
    ':' +
    z(d.getMinutes()) +
    ':' +
    z(d.getSeconds()) +
    '.' +
    zz(d.getMilliseconds()) +
    sign +
    z((off / 60) | 0) +
    ':' +
    z(off % 60)
  );
};

export function getDate(date?: dayjs.ConfigType, format?: string, locale?: string) {
  if (!date && !format) {
    return dayjs();
  }
  if (date && !format) {
    return dayjs(date);
  }

  return dayjs(date, format, locale);
}

export const getFormattedDate = (date: any, format: string, locale: string) => {
  if (!date) {
    return '';
  }

  if (typeof date === 'string') {
    return dayjs(date).locale(locale).format(format);
  }

  return dayjs(date, 'L').locale(locale).format(format);
};

export function transformDateToEuroFormat(date: any, locale: string) {
  const tmpDate = dayjs(date, 'L', locale).toDate();
  return tmpDate.toLocaleDateString('fr');
}

export const getBusinessDays = (daysToAdd: number) => {
  return dayjs().businessDaysAdd(daysToAdd);
};
